import { ThemeProperties } from '../../core';

export interface TableTheme {
	cardBackground: string;

	headerFont: string;
	headerSortedTextColor: string;
	headerBorderColor: string;
	headerSortUnderlineColor: string;
	headerSortIndicatorColor: string;
	headerSortIndicatorActiveColor: string;

	bodyFont: string;
	rowBorderColor: string;
	rowHoverBackground: string;
	rowActiveBackground: string;
	focusRingColor: string;
	emptyStateTextColor: string;

	paginationBackground: string;
}
export const theme = new ThemeProperties('table');
